export interface Movie {
  id: string;
  title: string;
  titleEn: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  duration: string;
  region: string;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  coverImage: string;
  bannerImage: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  updateDate: string;
  episodes: string;
  quality: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-movie-line', count: 128 },
  { name: '动作片', slug: 'action', icon: 'ri-sword-line', count: 35 },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 28 },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line', count: 22 },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line', count: 18 },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line', count: 15 },
  { name: '剧情片', slug: 'drama', icon: 'ri-emotion-line', count: 30 },
  { name: '动漫', slug: 'anime', icon: 'ri-palette-line', count: 42 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line', count: 16 },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    titleEn: 'The Wandering Earth 3',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.2,
    duration: '148分钟',
    region: '中国大陆',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类命运共同体再次集结，展开一场跨越星系的宏大冒险。',
    longDescription: '在《流浪地球3》中，地球已经启程离开太阳系，人类面临着前所未有的挑战。随着地球深入宇宙深处，新的威胁不断涌现——未知的外星文明、地球内部的资源危机、以及人类内部的分裂。刘培强等新一代宇航员肩负起拯救人类的重任，他们必须在浩瀚宇宙中找到生存的希望。本片延续了前两部的宏大叙事，将科幻与人文关怀完美结合，呈现了中国科幻电影的新高度。',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理', '王智'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20with%20astronaut%20in%20space%20suit%20against%20nebula%20background%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20dark%20cosmic%20colors%20with%20orange%20and%20blue%20accents%2C%20professional%20movie%20poster%20style&width=400&height=560&seq=movie-cover-1&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20massive%20spaceship%20and%20earth%20in%20background%2C%20cinematic%20wide%20shot%2C%20dramatic%20atmosphere%2C%20deep%20space%20with%20stars%2C%20orange%20and%20dark%20blue%20color%20palette%2C%20professional%20movie%20cinematography&width=1600&height=700&seq=movie-banner-1&orientation=landscape',
    tags: ['科幻', '冒险', '灾难', '太空', '国产巨制'],
    isHot: true,
    isNew: true,
    isRecommended: true,
    updateDate: '2026-08-01',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-2',
    title: '封神第二部：战火西岐',
    titleEn: 'Creation of the Gods II',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.9,
    duration: '156分钟',
    region: '中国大陆',
    description: '商朝末年，纣王暴虐无道。姬发在姜子牙等人的辅佐下，率领西岐大军讨伐商朝，一场波澜壮阔的神话史诗战争就此拉开帷幕。',
    longDescription: '《封神第二部：战火西岐》承接第一部剧情，西岐大军正式向商朝发起进攻。姜子牙运筹帷幄，哪吒、杨戬等仙家弟子各显神通，与纣王麾下的魔家四将、申公豹等展开惊天动地的大战。影片以磅礴的战争场面和精美的特效展现了中华神话的独特魅力，同时深入刻画了姬发、殷郊等人物的成长与抉择，是一部集视觉奇观与人文深度于一体的史诗巨制。',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰', '娜然'],
    coverImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythology%20movie%20poster%20with%20warriors%20in%20armor%20and%20mythical%20creatures%2C%20epic%20fantasy%20art%20style%2C%20gold%20and%20crimson%20color%20palette%2C%20dramatic%20composition&width=400&height=560&seq=movie-cover-2&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20ancient%20war%20scene%20with%20thousands%20of%20soldiers%20and%20mythical%20beasts%2C%20cinematic%20battle%20scene%2C%20dramatic%20sky%20with%20fire%20and%20smoke%2C%20gold%20and%20crimson%20tones&width=1600&height=700&seq=movie-banner-2&orientation=landscape',
    tags: ['神话', '战争', '史诗', '封神', '国产大片'],
    isHot: true,
    isNew: false,
    isRecommended: true,
    updateDate: '2026-07-25',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-3',
    title: '热辣滚烫2',
    titleEn: 'YOLO 2',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.7,
    duration: '129分钟',
    region: '中国大陆',
    description: '乐莹在拳击道路上继续前行，这次她将面对更强大的对手和更艰难的人生挑战。在汗水与笑声中，她找到了真正的自我。',
    longDescription: '《热辣滚烫2》延续了第一部的热血与温情，乐莹在赢得第一次比赛后，生活发生了翻天覆地的变化。她开始参加全国级别的比赛，面对职业选手的挑战，同时也遇到了新的朋友和对手。影片在保持喜剧风格的同时，更加深入探讨了女性成长、自我认同和梦想追求等主题。贾玲以其独特的幽默感和真诚的表演，再次为观众带来了一部笑中带泪的佳作。',
    director: '贾玲',
    cast: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%20with%20woman%20boxer%20in%20red%20boxing%20gloves%2C%20warm%20lighting%2C%20inspirational%20mood%2C%20bright%20red%20and%20warm%20yellow%20color%20scheme&width=400&height=560&seq=movie-cover-3&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Boxing%20ring%20scene%20in%20a%20gym%2C%20warm%20dramatic%20lighting%2C%20female%20boxer%20silhouette%2C%20inspirational%20sports%20movie%20cinematography%2C%20red%20and%20gold%20tones&width=1600&height=700&seq=movie-banner-3&orientation=landscape',
    tags: ['喜剧', '励志', '运动', '女性', '拳击'],
    isHot: true,
    isNew: false,
    isRecommended: true,
    updateDate: '2026-07-20',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-4',
    title: '消失的她2',
    titleEn: 'Lost in the Stars 2',
    year: 2026,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.5,
    duration: '135分钟',
    region: '中国大陆',
    description: '一位女子在异国失踪后，她的丈夫展开疯狂寻找。随着调查的深入，一个令人震惊的真相逐渐浮出水面，颠覆了所有人的认知。',
    longDescription: '《消失的她2》是一部扣人心弦的悬疑剧情片。故事发生在泰国，一位中国游客突然失踪，她的丈夫何非开始了绝望的寻找。但当他终于找到"妻子"时，却发现事情远比想象中复杂。影片通过巧妙的叙事结构和不间断的反转，将观众带入一个真假难辨的世界。朱一龙和倪妮的精湛演技为影片增添了强大的情感张力，探讨了爱情、真相与人性的边界。',
    director: '陈思诚',
    cast: ['朱一龙', '倪妮', '文咏珊', '杜江'],
    coverImage: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20movie%20poster%20with%20mysterious%20woman%20face%20half%20in%20shadow%2C%20noir%20style%2C%20dark%20blue%20and%20teal%20tones%2C%20film%20noir%20aesthetic&width=400&height=560&seq=movie-cover-4&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20tropical%20island%20at%20night%20with%20dark%20ocean%2C%20cinematic%20suspense%20atmosphere%2C%20foggy%20beach%2C%20noir%20lighting%2C%20deep%20blue%20and%20shadow&width=1600&height=700&seq=movie-banner-4&orientation=landscape',
    tags: ['悬疑', '犯罪', '剧情', '反转'],
    isHot: true,
    isNew: false,
    isRecommended: false,
    updateDate: '2026-07-15',
    episodes: 'HD',
    quality: '1080P',
  },
  {
    id: 'movie-5',
    title: '飞驰人生3',
    titleEn: 'Pegasus 3',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.4,
    duration: '126分钟',
    region: '中国大陆',
    description: '曾经的赛车冠军张驰再度出山，这次他将带领一支全新的车队，征战更加激烈的国际拉力赛，书写新的传奇。',
    longDescription: '《飞驰人生3》中，张驰已经成为了国内赛车界的传奇人物。当国际拉力赛来到中国，他决定再次挑战自我，组建一支由新老车手组成的梦之队。面对来自世界各地的顶尖车手，张驰和他的队友们不仅要克服技术上的挑战，更要战胜内心的恐惧与怀疑。影片在极速飙车的视觉冲击中，融入了关于梦想、友谊和传承的温情故事，笑点与泪点并存。',
    director: '韩寒',
    cast: ['沈腾', '范丞丞', '尹正', '张本煜', '孙艺洲'],
    coverImage: 'https://readdy.ai/api/search-image?query=Racing%20car%20movie%20poster%20with%20rally%20car%20on%20desert%20road%2C%20dust%20and%20speed%2C%20warm%20desert%20sunset%20colors%2C%20action%20comedy%20vibe&width=400&height=560&seq=movie-cover-5&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Desert%20rally%20race%20scene%20with%20multiple%20cars%20kicking%20up%20dust%2C%20golden%20sunset%20light%2C%20action%20sports%20cinematography%2C%20warm%20orange%20and%20brown%20tones&width=1600&height=700&seq=movie-banner-5&orientation=landscape',
    tags: ['喜剧', '赛车', '运动', '励志'],
    isHot: false,
    isNew: true,
    isRecommended: true,
    updateDate: '2026-07-30',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-6',
    title: '异形：夺命舰',
    titleEn: 'Alien: Romulus',
    year: 2026,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 8.1,
    duration: '119分钟',
    region: '美国',
    description: '一群年轻的太空拾荒者在一座废弃空间站中遭遇了宇宙中最可怕的生物形态，他们必须为自己的生存而战。',
    longDescription: '《异形：夺命舰》将异形系列的恐怖氛围推向新高度。故事设定在《异形》与《异形2》之间，一群年轻的太空拾荒者登上了一座看似废弃的空间站，却不知道这里隐藏着可怕的秘密。随着异形的出现，他们在狭窄的走廊和幽闭的空间中展开了一场惊心动魄的生存之战。影片回归了系列最初的幽闭恐怖风格，以精妙的惊吓设计和紧张的氛围营造，为观众带来最纯粹的恐怖体验。',
    director: '费德·阿尔瓦雷兹',
    cast: ['卡莉·史派妮', '伊莎贝拉·默塞德', '大卫·琼森'],
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20horror%20movie%20poster%20with%20alien%20creature%20silhouette%20in%20dark%20spaceship%20corridor%2C%20green%20and%20black%20color%20scheme%2C%20horror%20film%20aesthetic&width=400&height=560&seq=movie-cover-6&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20abandoned%20spaceship%20interior%20with%20flickering%20lights%2C%20horror%20sci-fi%20atmosphere%2C%20green%20emergency%20lighting%2C%20dark%20corridors%2C%20cinematic%20horror&width=1600&height=700&seq=movie-banner-6&orientation=landscape',
    tags: ['恐怖', '科幻', '太空', '异形', '惊悚'],
    isHot: false,
    isNew: true,
    isRecommended: false,
    updateDate: '2026-07-28',
    episodes: 'HD',
    quality: '1080P',
  },
  {
    id: 'movie-7',
    title: '长安三万里2',
    titleEn: 'Chang An 2',
    year: 2026,
    category: '动漫',
    categorySlug: 'anime',
    rating: 9.0,
    duration: '168分钟',
    region: '中国大陆',
    description: '以盛唐为背景，讲述李白、杜甫等诗人在安史之乱中的命运沉浮，用唯美的画面再现大唐诗歌的辉煌时代。',
    longDescription: '《长安三万里2》延续第一部的史诗叙事，将时间线推进到安史之乱爆发后。李白、杜甫、高适等诗人的命运在战火中交织，他们各自的诗歌创作也迎来了巅峰时期。影片以精美的国风动画呈现了大唐由盛转衰的历史画卷，同时深入诗人们的内心世界，展现他们在乱世中的坚守与挣扎。每一帧画面都如同一幅精美的国画，配合着千古流传的诗句，为观众带来一场视听与心灵的双重盛宴。',
    director: '谢君伟',
    cast: ['杨天翔', '凌振赫', '吴俊全'],
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20ancient%20poetry%20animation%20movie%20poster%2C%20Tang%20dynasty%20scholar%20under%20moonlight%2C%20traditional%20Chinese%20ink%20painting%20style%2C%20elegant%20gold%20and%20ink%20color%20palette&width=400&height=560&seq=movie-cover-7&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20city%20Chang%20An%20at%20sunset%2C%20Tang%20dynasty%20architecture%2C%20traditional%20Chinese%20painting%20style%2C%20golden%20light%2C%20elegant%20and%20poetic%20atmosphere&width=1600&height=700&seq=movie-banner-7&orientation=landscape',
    tags: ['动画', '历史', '诗歌', '唐朝', '国风'],
    isHot: false,
    isNew: false,
    isRecommended: true,
    updateDate: '2026-07-10',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-8',
    title: '志愿军：存亡之战',
    titleEn: 'The Volunteers: To the War',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 9.1,
    duration: '152分钟',
    region: '中国大陆',
    description: '以抗美援朝战争为背景，讲述中国人民志愿军在极端恶劣条件下英勇作战、保家卫国的壮烈故事。',
    longDescription: '《志愿军：存亡之战》聚焦抗美援朝战争中最惨烈的战役之一，全景式展现了志愿军战士们在冰天雪地中与装备精良的敌军展开殊死搏斗的英勇事迹。影片以宏大的战争场面和细腻的人物刻画，还原了那段可歌可泣的历史。从普通士兵到高级将领，每个人都面临着生与死的考验，他们用血肉之躯筑起了保家卫国的钢铁长城。',
    director: '陈凯歌',
    cast: ['朱一龙', '张子枫', '辛柏青', '章宇', '张颂文'],
    coverImage: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20in%20snow%20battlefield%2C%20dramatic%20winter%20scene%2C%20khaki%20and%20white%20color%20palette%2C%20heroic%20war%20film%20style&width=400&height=560&seq=movie-cover-8&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20winter%20war%20battlefield%20scene%20with%20soldiers%20in%20snow%2C%20cinematic%20war%20photography%2C%20explosions%20and%20smoke%2C%20cold%20blue%20and%20white%20tones&width=1600&height=700&seq=movie-banner-8&orientation=landscape',
    tags: ['战争', '历史', '抗美援朝', '爱国'],
    isHot: false,
    isNew: false,
    isRecommended: true,
    updateDate: '2026-07-05',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-9',
    title: '熊出没·逆转时空',
    titleEn: 'Boonie Bears: Time Twist',
    year: 2026,
    category: '动漫',
    categorySlug: 'anime',
    rating: 8.3,
    duration: '105分钟',
    region: '中国大陆',
    description: '光头强和熊大熊二意外穿越时空，在恐龙时代、未来世界展开了一场笑料百出又温情满满的冒险之旅。',
    longDescription: '《熊出没·逆转时空》是该系列最富想象力的一部作品。光头强发明了一台时空机器，却意外将他和熊大熊二传送到了不同的时代。他们在侏罗纪与恐龙赛跑，在古代帮助一位小将军守卫城池，在未来世界与机器人斗智斗勇。影片在保持系列一贯的幽默风格的同时，也传达了对友情、家庭和环保的深刻思考，是一部适合全家观看的优质国产动画电影。',
    director: '林汇达',
    cast: ['张伟', '张秉君', '谭笑'],
    coverImage: 'https://readdy.ai/api/search-image?query=Cute%203D%20animated%20movie%20poster%20with%20bears%20and%20time%20travel%20portal%2C%20colorful%20and%20playful%20style%2C%20bright%20green%20and%20blue%20colors&width=400&height=560&seq=movie-cover-9&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Colorful%20animated%20jungle%20scene%20with%20time%20portal%20and%20dinosaurs%2C%20playful%20animation%20style%2C%20bright%20and%20vibrant%20colors&width=1600&height=700&seq=movie-banner-9&orientation=landscape',
    tags: ['动画', '喜剧', '冒险', '合家欢', '穿越'],
    isHot: false,
    isNew: false,
    isRecommended: false,
    updateDate: '2026-06-28',
    episodes: 'HD',
    quality: '1080P',
  },
  {
    id: 'movie-10',
    title: '一闪一闪亮星星',
    titleEn: 'Shining Stars',
    year: 2026,
    category: '爱情片',
    categorySlug: 'romance',
    rating: 8.0,
    duration: '112分钟',
    region: '中国大陆',
    description: '林北星在不断的时空循环中回到过去，试图拯救心爱之人张万森。跨越时空的爱恋，能否改变命运的轨迹？',
    longDescription: '《一闪一闪亮星星》是一部温暖治愈的奇幻爱情片。林北星发现每当她对着天空中最亮的那颗星许愿，她就会回到过去的某个关键时刻。在一次次的时空穿越中，她试图改写张万森的命运，却逐渐发现每一次改变都会带来意料之外的连锁反应。影片以清新唯美的画面和真挚动人的情感，讲述了一个关于爱与遗憾、命运与选择的故事，让人在感动之余思考生命的意义。',
    director: '陈小明',
    cast: ['屈楚萧', '张佳宁', '傅菁'],
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20fantasy%20movie%20poster%20with%20couple%20under%20starry%20sky%2C%20dreamy%20purple%20and%20blue%20twilight%20colors%2C%20soft%20focus%20cinematic%20style&width=400&height=560&seq=movie-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20starry%20night%20sky%20over%20a%20quiet%20city%2C%20romantic%20atmosphere%2C%20twinkling%20stars%2C%20purple%20and%20deep%20blue%20night%20sky&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    tags: ['爱情', '奇幻', '时空穿越', '治愈'],
    isHot: false,
    isNew: false,
    isRecommended: false,
    updateDate: '2026-06-20',
    episodes: 'HD',
    quality: '1080P',
  },
  {
    id: 'movie-11',
    title: '深海2',
    titleEn: 'Deep Sea 2',
    year: 2026,
    category: '动漫',
    categorySlug: 'anime',
    rating: 8.8,
    duration: '118分钟',
    region: '中国大陆',
    description: '参宿在深海大饭店的经历后，再次踏上奇幻之旅。这次她将探索更深的海域，发现一个被遗忘的海底文明。',
    longDescription: '《深海2》延续了前作令人惊艳的视觉风格，以更加宏大的叙事格局讲述了一个关于成长与和解的故事。参宿在经历过深海大饭店的奇遇后，收到了来自海底深处的一封神秘信件。她再次潜入深海，这次发现了隐藏在海沟之中的古老海底文明。在那里，她遇到了新的朋友，也面对了内心深处的恐惧。影片以令人窒息的视觉美学和深刻的情感内核，再次刷新了国产动画的艺术高度。',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文'],
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20Chinese%20animation%20movie%20poster%20with%20underwater%20world%20and%20colorful%20sea%20creatures%2C%20particle%20effects%2C%20deep%20ocean%20blue%20with%20neon%20colors&width=400&height=560&seq=movie-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Magical%20underwater%20world%20with%20bioluminescent%20creatures%2C%20colorful%20coral%20reefs%2C%20deep%20ocean%20atmosphere%2C%20dreamy%20particle%20effects&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    tags: ['动画', '奇幻', '冒险', '深海', '治愈'],
    isHot: false,
    isNew: true,
    isRecommended: true,
    updateDate: '2026-07-29',
    episodes: 'HD',
    quality: '4K',
  },
  {
    id: 'movie-12',
    title: '三大队',
    titleEn: 'The Three Teams',
    year: 2026,
    category: '剧情片',
    categorySlug: 'drama',
    rating: 8.6,
    duration: '142分钟',
    region: '中国大陆',
    description: '一名刑警在追捕逃犯的过程中，经历了人生的跌宕起伏。十二年的坚持，只为追寻一个真相和正义。',
    longDescription: '《三大队》根据真实事件改编，讲述了一个关于坚守与信念的故事。刑警程兵在一起重大案件中犯下错误，导致嫌疑人逃脱。此后的十二年里，他从一名意气风发的刑警变成了阶下囚，出狱后又成了四处漂泊的普通人。但无论身份如何变化，他始终没有放弃追捕那个逍遥法外的罪犯。影片以平实而有力的叙事，展现了一个普通人在逆境中的坚韧与执着，令人肃然起敬。',
    director: '戴墨',
    cast: ['张译', '李晨', '魏晨', '曹炳琨', '王骁'],
    coverImage: 'https://readdy.ai/api/search-image?query=Crime%20drama%20movie%20poster%20with%20detective%20in%20rainy%20street%2C%20noir%20atmosphere%2C%20dark%20and%20moody%20tones%2C%20serious%20expression&width=400&height=560&seq=movie-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Rainy%20city%20street%20at%20night%2C%20crime%20drama%20cinematography%2C%20lonely%20figure%20under%20street%20light%2C%20dark%20moody%20atmosphere&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    tags: ['剧情', '犯罪', '真实事件', '悬疑'],
    isHot: false,
    isNew: false,
    isRecommended: false,
    updateDate: '2026-06-15',
    episodes: 'HD',
    quality: '1080P',
  },
];

export const faqItems = [
  {
    question: '91影视看片下载是否需要注册？',
    answer: '不需要。91影视看片下载是一个完全免费的在线影视平台，用户无需注册即可观看所有影片内容。我们致力于为用户提供最便捷的观影体验，让您随时随地享受高清影视。',
  },
  {
    question: '天美麻花星空影视免费观看电视如何操作？',
    answer: '天美麻花星空影视免费观看电视操作非常简单。您只需访问我们的网站，在首页选择您想观看的影片，点击即可进入播放页面。我们的平台支持多种设备，包括电脑、平板和手机，让您随时随地畅享影视盛宴。',
  },
  {
    question: '麻花星空影视免费观看支持哪些清晰度？',
    answer: '麻花星空影视免费观看支持多种清晰度选择，包括1080P高清和4K超高清画质。系统会根据您的网络状况自动推荐最佳清晰度，您也可以手动切换以获得最佳观影体验。',
  },
  {
    question: '免费影视大全会每日更新吗？',
    answer: '是的，免费影视大全每日更新最新影视资源。我们的团队全天候监控各大平台的最新影片上线情况，确保您在第一时间能够观看到最新的电影、电视剧和动漫内容。',
  },
  {
    question: '在91影视看片下载观看需要安装什么软件？',
    answer: '完全不需要安装任何软件。91影视看片下载是一个在线流媒体平台，您只需要使用浏览器访问我们的网站即可观看所有内容。我们推荐使用Chrome、Edge或Safari等主流浏览器以获得最佳体验。',
  },
  {
    question: '为什么选择天美麻花星空影视免费观看电视？',
    answer: '选择天美麻花星空影视免费观看电视的理由有很多：海量正版影视资源、高清流畅播放体验、无需注册即可观看、每日更新最新内容、多设备支持随时随地追剧。我们始终以用户体验为核心，打造最好的免费影视平台。',
  },
];

export const testimonials = [
  {
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20headshot%2C%20neutral%20expression%2C%20clean%20white%20background%2C%20professional%20lighting&width=80&height=80&seq=avatar-1&orientation=squarish',
    content: '91影视看片下载真的是我见过最好的免费影视平台！片源丰富，更新速度极快，而且画质非常清晰。现在我和家人都用这个平台追剧，强烈推荐！',
    rating: 5,
  },
  {
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20headshot%2C%20friendly%20smile%2C%20clean%20white%20background%2C%20professional%20lighting&width=80&height=80&seq=avatar-2&orientation=squarish',
    content: '天美麻花星空影视免费观看电视真是太方便了！不用下载任何软件，打开浏览器就能看，而且分类很清晰，找片非常方便。每天都有新内容，永远不愁没剧看。',
    rating: 5,
  },
  {
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20male%20student%20portrait%20headshot%2C%20casual%20style%2C%20clean%20white%20background%2C%20natural%20lighting&width=80&height=80&seq=avatar-3&orientation=squarish',
    content: '作为一个动漫迷，麻花星空影视免费观看的动漫资源真的超全！从经典老番到最新番剧应有尽有，而且字幕翻译质量很高，观影体验很棒。',
    rating: 5,
  },
  {
    name: '赵女士',
    avatar: 'https://readdy.ai/api/search-image?query=Middle-aged%20Chinese%20woman%20portrait%20headshot%2C%20warm%20smile%2C%20clean%20white%20background%2C%20soft%20lighting&width=80&height=80&seq=avatar-4&orientation=squarish',
    content: '免费影视大全让我在通勤路上不再无聊，手机观看也很流畅。最喜欢的是没有广告打扰，观影体验非常纯粹。感谢平台提供这么好的服务！',
    rating: 5,
  },
];